export enum TRANSCRIPT_SOCKET_EVENTS {
    STATUS = "call-transcript:status",
}

export enum SOCKET_NAMESPACES {
    CALL_TRANSCRIPT = "call-transcript",
    REMOTE_CONFIG = "remote-config",
    USER_STATUS = "user-status",
}
